export type NumberLotteryFieldName = ObjectValues<typeof NUMBER_LOTTERY_FIELD_NAME>

export type NumberLotteryPerPlayAddOnName = ObjectValues<typeof NUMBER_LOTTERY_PER_PLAY_ADD_ON_NAME>

export const NUMBER_LOTTERY_FIELD_NAME = {
  Base: 'BASE',
  Extra: 'EXTRA',
} as const

export const NUMBER_LOTTERY_PER_PLAY_ADD_ON_NAME = {
  ExtraHit: 'extrahit',
} as const

export const NUMBER_LOTTERY_CARD_HEADLINE_OFFSET = 64

export const NUMBER_LOTTERY_SCROLL_TOLERANCE = 2
